import { useState } from "react";
import { ButtonAsButton } from "@made-people/blueprint-button";
import { useTranslate } from "@made-people/grease-translations";
import {
  loginDrawerOverlayId,
  resetPasswordDrawerOverlayId,
} from "../constants";
import { useDrawerNavigation } from "../hooks/use-drawer-navigation";
import { useResetPasswordForm } from "../hooks/use-reset-password-form";
import { AuthDrawer } from "./AuthDrawer";
import { ResetPasswordForm } from "../forms/ResetPasswordForm";

export const ResetPasswordDrawer = () => {
  const translate = useTranslate();
  const { switchToDrawer, resetStateAfterClose } = useDrawerNavigation();
  const [emailSent, setEmailSent] = useState(false);

  const form = useResetPasswordForm({
    onEmailSent: () => setEmailSent(true),
  });

  const resetState = () => {
    resetStateAfterClose(() => {
      form.setEmail("");
      setEmailSent(false);
    });
  };

  const switchToLogin = (e: React.MouseEvent) => {
    e.preventDefault();
    resetState();
    switchToDrawer(loginDrawerOverlayId);
  };

  return (
    <AuthDrawer
      overlayId={resetPasswordDrawerOverlayId}
      heading={translate("Account_ResetPassword_Heading")}
    >
      {!emailSent ? (
        <ResetPasswordForm
          form={form}
          loginAction={
            <ButtonAsButton
              label={translate("Account_ResetPassword_SecondaryAction")}
              onClick={(e) => {
                switchToLogin(e as React.MouseEvent);
              }}
              variants={{ style: "outline", width: "full" }}
            />
          }
        />
      ) : (
        <div className="flex flex-col gap-6">
          <div className="flex flex-col gap-2 md:gap-4">
            <h2 className="text-heading-sm">
              {translate("Account_ResetPassword_EmailHasBeenSent_Heading")}
            </h2>
            <p className="text-body-md">
              {translate("Account_ResetPassword_EmailHasBeenSent_Lead")}
            </p>
          </div>

          <ButtonAsButton
            label={translate(
              "Account_ResetPassword_EmailHasBeenSent_PrimaryAction",
            )}
            onClick={() => {
              resetState();
              switchToDrawer(loginDrawerOverlayId);
            }}
            variants={{ width: "full" }}
          />
        </div>
      )}
    </AuthDrawer>
  );
};
